import { useNavigate } from "react-router-dom";
import { Diamond, Hourglass, Lock, Sparkles } from "lucide-react";

import { membershipLabel } from "@/lib/format";

/** Status card used on the Profile dashboard (clickable) and the Membership page. */
export function MembershipStatusCard({ membership: m, onClick }) {
  if (!m || m.status === "exempt") return null;
  const expired = m.locked;
  const Icon = expired ? Lock : m.status === "active" ? Diamond : Hourglass;
  const Wrap = onClick ? "button" : "div";
  return (
    <Wrap type={onClick ? "button" : undefined} data-testid="membership-status-card" onClick={onClick}
      className={`flex w-full items-center gap-3 rounded-[20px] border p-4 text-left transition-shadow ${onClick ? "hover:shadow-md" : ""} ${expired ? "border-[#9E3C3E]/40 bg-[#9E3C3E]/5" : m.status === "active" ? "border-primary/40 bg-[#F6E3E4]" : "border-border bg-white"}`}>
      <Icon className={`h-[22px] w-[22px] shrink-0 ${expired ? "text-[#9E3C3E]" : "text-primary"}`} />
      <span className="flex-1">
        <span className="block text-[15px] font-bold" data-testid="membership-status-label">{membershipLabel(m)}</span>
        <span className="mt-0.5 block text-xs text-muted-foreground">
          {expired ? "Browsing is free. Premium unlocks requests, accepting and WhatsApp." : m.status === "trial" ? "Enjoy every feature during your trial." : "All premium features unlocked."}
        </span>
      </span>
      {onClick ? <span className="text-sm font-bold text-primary">{expired || m.status === "trial" ? "Upgrade" : "Manage"}</span> : null}
    </Wrap>
  );
}

/** Discover banner: last 3 days of trial/plan, or after expiry. */
export function MembershipBanner({ membership: m }) {
  const navigate = useNavigate();
  if (!m || m.status === "exempt") return null;
  const ending = !m.locked && (m.days_left ?? 99) <= 3;
  if (!ending && !m.locked) return null;
  const text = m.locked
    ? "Your free access has ended — continue with Premium to send requests."
    : `${m.status === "trial" ? "Your free trial" : "Your membership"} ends in ${m.days_left} day${m.days_left === 1 ? "" : "s"}.`;
  return (
    <button data-testid="membership-banner" onClick={() => navigate("/membership")} className="mb-6 flex w-full items-center gap-3 rounded-[20px] bg-primary p-4 text-left text-white transition-colors hover:bg-[#5c1f2a]">
      <Sparkles className="h-[18px] w-[18px] shrink-0" />
      <span className="flex-1 text-sm font-medium">{text}</span>
      <span className="text-sm font-bold underline-offset-2 hover:underline">See plans</span>
    </button>
  );
}
